import { isArray, mergeWith } from 'es-toolkit/compat';

export default function merge(source: any, ...targets: any[]) {
    function customizer(objValue: any, srcValue: any) {
        if (isArray(objValue)) {
            return srcValue;
        }
    }

    return mergeWith(source, ...targets, customizer);
}
